import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

/**
 * TextReveal — word-by-word staggered reveal with blur. Emil Kowalski signature.
 */
export function TextReveal({ children, className = '', delay = 0, as: Tag = 'h1' }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-40px' });

  const text = typeof children === 'string' ? children : '';
  const words = text.split(' ');

  return (
    <Tag ref={ref} className={className}>
      {words.map((word, i) => (
        <motion.span
          key={`${word}-${i}`}
          initial={{ opacity: 0, y: 12, filter: 'blur(4px)' }}
          animate={isInView ? { opacity: 1, y: 0, filter: 'blur(0px)' } : undefined}
          transition={{
            duration: 0.5,
            delay: delay + i * 0.04,
            ease: [0.21, 0.47, 0.32, 0.98],
          }}
          style={{ display: 'inline-block', marginRight: '0.25em' }}
        >
          {word}
        </motion.span>
      ))}
    </Tag>
  );
}

/**
 * LetterPull — letters pull up from below, used for hero headlines.
 */
export function LetterPull({ children, className = '', delay = 0, as: Tag = 'span' }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-40px' });
  const text = typeof children === 'string' ? children : '';

  return (
    <Tag ref={ref} className={className} style={{ display: 'inline-block', overflow: 'hidden' }}>
      {text.split('').map((char, i) => (
        <motion.span
          key={`${char}-${i}`}
          initial={{ y: '100%', opacity: 0 }}
          animate={isInView ? { y: '0%', opacity: 1 } : undefined}
          transition={{
            duration: 0.5,
            delay: delay + i * 0.025,
            ease: [0.215, 0.61, 0.355, 1],
          }}
          style={{ display: 'inline-block' }}
        >
          {char === ' ' ? '\u00A0' : char}
        </motion.span>
      ))}
    </Tag>
  );
}
